import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Currency } from 'src/app/commons/models/currency.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as CurrencyActions from 'src/app/store/actions/currency.actions';
import { AppState } from 'src/app/store/reducers';
import * as CurrencySelectors from 'src/app/store/selectors/currency.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { CurrencyFilters } from './../../../commons/models/currency.model';
import { CurrenciesColumn } from '../currency-list/currency-list.component';



@Component({
  selector: 'app-currency-selection',
  templateUrl: './currency-selection.component.html',
  styleUrls: ['./currency-selection.component.scss']
})
export class CurrencySelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  currencies: Observable<Currency[]>;
  filters: Observable<CurrencyFilters>;

  @Input()
  defaultFilters: CurrencyFilters = {
    search: "",
  }

  displayedColumns: CurrenciesColumn[] = ["currencyCode", "name", "actions"]; // "exchangeRate"

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.currencies = this.store$.pipe(select(CurrencySelectors.getCurrencies), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new Currency(dto)) : null));
    this.total = this.store$.pipe(select(CurrencySelectors.getTotalCurrencies), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(CurrencySelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(CurrencyActions.loadCurrencies(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(CurrencyActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(CurrencyActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: CurrencyFilters) {
    this.store$.dispatch(CurrencyActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectCurrency(currency: Currency) {
    if (currency) {
      this.store$.dispatch(CurrencyActions.currencySelected({ currency: currency.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(CurrencyActions.closeSelectionDialog())
  }
}
